import { addDays } from 'date-fns';
import { availableCurrencies } from './Currency';
import { CITY_OPTIONS } from './CitiesFrom';

export function initDepartureDate() {
  const result = {};
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  result.from = addDays(today, 14);
  result.to = addDays(today, 16);

  return result;
}

export const initalDepartureCity = CITY_OPTIONS[0];
export const initalDepartureHotel = { id: 99 };

export const turkey = {
  id: '4',
  name: 'Турция',
  type: 'country',
  rank: 1,
  visa: false,
};

export const egypt = {
  id: '1',
  name: 'Египет',
  rank: 2,
  type: 'country',
  visa: false,
};

export const uea = {
  id: '9',
  name: 'ОАЭ',
  rank: 3,
  type: 'country',
  visa: false,
};

export const georgia = {
  id: '54',
  name: 'Грузия',
  rank: 4,
  type: 'country',
  visa: false,
};

export const initialDestinationCountry = turkey;
export const initialNightsFrom = 7;
export const initialNightsTo = 11;
export const initialAdultsCount = 2;
export const initialKids = [];
export const initialCurrency = availableCurrencies[1];
